import React from "react";
import { Link } from "react-router-dom";
import Cookies from "cookies-js";
import { logToAndylitics } from "../../api/andyliticsApi";
import PropTypes from 'prop-types';

const NO_REDIRECT = 'noredirect'; // cookie to prevent redirect


class MobileAppBanner extends React.Component {
    constructor(params) {        
        super(params);
        const { showBanner, ssoBaseURL } = this.props;
        this.state = {
            showBanner
        };
        
        this.GOOGLE_PLAY_URL = `${ssoBaseURL}app_download/android`;
        this.IPHONE_APP_URL = `${ssoBaseURL}app_download/iphone`;
        this.downloadMobileApp = this.downloadMobileApp.bind(this);
        this.closeMobileBanner = this.closeMobileBanner.bind(this);
    }    


    componentDidMount() {
        logToAndylitics('MBHWeb.UI.Home.AppDownload.ComponentDidMount', new Date(), '/AppDownload');
        window.setTimeout(this.closeMobileBanner, 25000); // close after 25 seconds
    }
    closeMobileBanner() {       
        try {
            const { mobilePromptExpirationInDays } = this.props;
            this.setState({
                showBanner: false
            });
            // SETS COOKIE SO DOES NOT DISPLAY AD UNTIL X AMOUNT OF DAYS LATER
            if (!Cookies.get(NO_REDIRECT)) {
                const dDate = new Date();
                logToAndylitics('MBHWeb.Home.AppDownload.Cancel.ContinueToWeb', new Date(), '/AppDownload');
                //add session cookie so prompt does not display after first page
                const expiration = new Date(new Date().getTime() + parseInt(mobilePromptExpirationInDays) * 1000 * 60 * 60 * 24);
                Cookies.set(NO_REDIRECT, 'true', { path: '/', 'expires': expiration });
            }
        }
        catch (e) {

        }
    }   

    downloadMobileApp() {
        //DOWNLOAD APP BUTTON THAT DIRECTS USER TO CORRESPONDING APP STORE TO DOWNLOAD APP        
        const {  isIos, isAndroid } = this.props;
        const dDate = new Date();
        if (isIos) {           
            if (typeof window !== 'undefined') 
                window.location.href = this.IPHONE_APP_URL;                
            logToAndylitics('MBHWeb.Home.iTunes.Redirect', new Date(), '/iTunesDownload');           
        }
        else if (isAndroid) {
            if (typeof window !== 'undefined') 
                window.location.href = this.GOOGLE_PLAY_URL;            
            logToAndylitics('MBHWeb.Home.GooglePlay.Redirect', new Date(), '/GooglePlayDownload');
        }
    }

    render() {
        const { showBanner } = this.state;
        const { redirectUrl, careOptions } = this.props;
        const careOptionType = careOptions ? careOptions : "Convenient Care Options";
        const careOptionsImg = careOptionType.toLowerCase().split(" ");
        const imageSrc = "/images/" + careOptionsImg[0] + "-mobile-dwnld.png";

        return (
            <div className="container-fluid mobile-app-banner-container">
                {showBanner && 
                    <div className="row">
                        <div className="col-12 maxWidth-content">
                            <div className="row mobile-app-banner__heading">
                                <div className="col-12">
                                    <h1 className="banner-heading">Getting better <br />starts here</h1>
                                </div>
                            </div>
                            <div className="row mobile-app-banner__body">

                                <div className="col-12">
                                    <div className="banner-message">With the MyBSWHealth App you can manage your health from anywhere.</div>
                                </div>
                            <div className="col-12">
                                <div className="mobile-phone-bg"><img alt="download-mobile-app" src={imageSrc} className="img-fluid" /></div>
                                    <div className="mobile-app-rating">
                                        <div className="mobile-app-rating__overall">4.7 Rating</div>
                                        <div className="mobile-app-rating__stars"><img alt="mobile-app-star-rating" src="/images/mobile-app-star-rating.jpg" className="img-fluid" /></div>
                                        <div className="mobile-app-rating__details">with 17k+ reviews <br />& 300k+ users</div>
                                    </div>
                                </div>
                            </div>
                            <div className="row mobile-app-banner__footer">
                                <div className="col-12 banner-buttons">
                                    <div className="row align-items-center">
                                    <div className="col text-center">
                                        <Link to="#" className="banner-buttons__skip" onClick={this.closeMobileBanner}>SKIP FOR NOW</Link>
                                        </div>
                                        <div className="col text-center">
                                            <Link className="banner-buttons__download btn btn-primary" to="/" onClick={this.downloadMobileApp}>DOWNLOAD APP</Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </div>
        );
    }
}

MobileAppBanner.propTypes = {
    showBanner: PropTypes.bool.isRequired,
    mobilePromptExpirationInDays: PropTypes.number.isRequired,
    ssoBaseURL: PropTypes.string.isRequired,
    isAndroid: PropTypes.bool.isRequired,
    isIos: PropTypes.bool.isRequired
};

export default MobileAppBanner;